import React from "react";
import { Provider } from "react-redux";
import "regenerator-runtime/runtime";
import { BrowserRouter } from "react-router-dom"
import { AuthProvider } from "./src/auth";
import Config from "./src/common/Config";
import createReduxStore from "./src/reducers";
import HeaderFooterLayout from './src/layouts/HeaderFooterLayout'

export const wrapRootElement = ({ element }) => {
    const store = createReduxStore();
    const origin = window.location.origin
    let { baseName } = Config
    if (baseName !== '/') baseName += '/'
    const redirectUri = `${origin}${baseName}app/callback`
    const postLogoutRedirectUri = `${origin}${baseName}app/logout-callback`

	return (
        <Provider store={store}>
            <BrowserRouter>
                <AuthProvider
                    authority={Config.oidcAuthority}
                    clientId={'dev-portal'}
                    redirectUri={redirectUri}
                    postLogoutRedirectUri={postLogoutRedirectUri}
                    loginUrl={`${window.location.origin}/app/login`}
                >
                    {element}
                </AuthProvider>
            </BrowserRouter>
        </Provider>
    );
}

export const wrapPageElement = ({ element }) => {
    return <HeaderFooterLayout>{element}</HeaderFooterLayout>
}
